var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgExtractText = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M6.375 11.396c0-.222.176-.403.394-.403h3.15c.217 0 .393.18.393.403a.4.4 0 0 1-.393.403h-3.15a.4.4 0 0 1-.394-.403m3.281 4.697c0-.222.177-.402.394-.402h3.806c.218 0 .394.18.394.402a.4.4 0 0 1-.394.403H10.05a.4.4 0 0 1-.394-.403m0-2.348c0-.223.177-.403.394-.403h3.806c.218 0 .394.18.394.403a.4.4 0 0 1-.394.402H10.05a.4.4 0 0 1-.394-.402"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M13.601 5.625H8.344c-.725 0-1.313.6-1.313 1.342v2.819c0 .222.177.402.394.402s.394-.18.394-.402V6.967c0-.296.235-.537.525-.537h4.594v2.55c0 .37.293.671.656.671h2.493v7.382a.53.53 0 0 1-.524.537h-7.22a.53.53 0 0 1-.524-.537v-4.026a.4.4 0 0 0-.394-.403.4.4 0 0 0-.394.403v4.026c0 .741.588 1.342 1.313 1.342h7.219c.724 0 1.312-.6 1.312-1.342V8.968h-.002a.67.67 0 0 0-.194-.462l-2.621-2.682a.63.63 0 0 0-.457-.198z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExtractText);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/extract-text.fce1d350.svg";